import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Orders } from './pages/Orders';
import { Expenses } from './pages/Expenses';
import { Transport } from './pages/Transport';
import TransportOrders from './pages/TransportOrders';
import TransportRecap from './pages/TransportRecap';
import TransportSuiviPage from './pages/TransportSuiviPage';
import CheckinDashboard from './pages/CheckinDashboard';
import { Commercials } from './pages/Commercials';
import { Partners } from './pages/Partners';
import { PartnerDashboard } from './pages/PartnerDashboard';
import { ManagerDashboard } from './pages/ManagerDashboard';
import { Archives } from './pages/Archives';
import { Clients } from './pages/Clients';
import { Products } from './pages/Products';
import { Settings } from './pages/Settings';
import { Toaster } from './components/ui/sonner';
import ResetPassword from './pages/ResetPassword';
import SizeGuide from './pages/SizeGuide';
import Support from './pages/Support';
import Personalization from './pages/Personalization';
import DesignAdmin from './pages/DesignAdmin';
import DesignGenerator from './pages/DesignGenerator';
import EmailTemplates from './pages/EmailTemplates';
import Quotes from './pages/Quotes';
import ClientQuotes from './pages/ClientQuotes';
import ProductPricing from './pages/ProductPricing';
import DesignerDashboard from './pages/DesignerDashboard';
import DesignerDesigns from './pages/DesignerDesigns';
import DesignerPatterns from './pages/DesignerPatterns';
import DesignRequests from './pages/DesignRequests';
import DesignerInvoices from './pages/DesignerInvoices';
import PremiumAdmin from './pages/PremiumAdmin';
import Suppliers from './pages/Suppliers';
import PublicTracking from './pages/PublicTracking';
import RevendeurDashboard from './pages/RevendeurDashboard';
import RevendeurLogin from './pages/RevendeurLogin';
import ClientLogin from './pages/ClientLogin';
import ClientDashboard from './pages/ClientDashboard';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/track" element={<PublicTracking />} />
            <Route path="/revendeur/login" element={<RevendeurLogin />} />
            <Route path="/revendeur" element={<RevendeurDashboard />} />
            <Route path="/espace-client" element={<ClientLogin />} />
            <Route path="/espace-client/dashboard" element={<ClientDashboard />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
            <Route path="/commercials" element={<ProtectedRoute><Commercials /></ProtectedRoute>} />
            <Route path="/partners" element={<ProtectedRoute><Partners /></ProtectedRoute>} />
            <Route path="/partner-dashboard" element={<ProtectedRoute><PartnerDashboard /></ProtectedRoute>} />
            <Route path="/manager-dashboard" element={<ProtectedRoute><ManagerDashboard /></ProtectedRoute>} />
            <Route path="/archives" element={<ProtectedRoute><Archives /></ProtectedRoute>} />
            <Route path="/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
            <Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
            <Route path="/expenses" element={<ProtectedRoute><Expenses /></ProtectedRoute>} />
            <Route path="/transport" element={<ProtectedRoute><Transport /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/size-guide" element={<ProtectedRoute><SizeGuide /></ProtectedRoute>} />
            <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
            <Route path="/personalization" element={<ProtectedRoute><Personalization /></ProtectedRoute>} />
            <Route path="/design-admin" element={<ProtectedRoute><DesignAdmin /></ProtectedRoute>} />
            <Route path="/design-generator" element={<ProtectedRoute><DesignGenerator /></ProtectedRoute>} />
            <Route path="/email-templates" element={<ProtectedRoute><EmailTemplates /></ProtectedRoute>} />
            <Route path="/quotes" element={<ProtectedRoute><Quotes /></ProtectedRoute>} />
            <Route path="/product-pricing" element={<ProtectedRoute><ProductPricing /></ProtectedRoute>} />
            <Route path="/premium-admin" element={<ProtectedRoute><PremiumAdmin /></ProtectedRoute>} />
            <Route path="/suppliers" element={<ProtectedRoute><Suppliers /></ProtectedRoute>} />
            <Route path="/client-quotes" element={<ProtectedRoute><ClientQuotes /></ProtectedRoute>} />
            <Route path="/transport-orders" element={<ProtectedRoute><TransportOrders /></ProtectedRoute>} />
            <Route path="/transport-recap" element={<ProtectedRoute><TransportRecap /></ProtectedRoute>} />
            <Route path="/transport-suivi" element={<ProtectedRoute><TransportSuiviPage /></ProtectedRoute>} />
            <Route path="/checkin-dashboard" element={<ProtectedRoute><CheckinDashboard /></ProtectedRoute>} />
            <Route path="/designer-dashboard" element={<ProtectedRoute><DesignerDashboard /></ProtectedRoute>} />
            <Route path="/designer-designs" element={<ProtectedRoute><DesignerDesigns /></ProtectedRoute>} />
            <Route path="/designer-patterns" element={<ProtectedRoute><DesignerPatterns /></ProtectedRoute>} />
            <Route path="/designer-invoices-view" element={<ProtectedRoute><DesignerInvoices /></ProtectedRoute>} />
            <Route path="/design-requests" element={<ProtectedRoute><DesignRequests /></ProtectedRoute>} />
            <Route path="/designer-invoices" element={<ProtectedRoute><DesignerInvoices /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
